/**
 * 会员相册请求接口
 * @author 王振宇
 * @since 2022-05-05
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MEMBERPICTURES_PAGE_LIST: function GET_MEMBERPICTURES_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERPICTURES_LIST: function GET_MEMBERPICTURES_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/getList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERPICTURES_INFO: function GET_MEMBERPICTURES_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MEMBERPICTURES: function SAVE_MEMBERPICTURES() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBERPICTURES: function UPDATE_MEMBERPICTURES() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MEMBERPICTURES: function DELETE_MEMBERPICTURES() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MEMBERPICTURES: function DELETE_BATCH_MEMBERPICTURES() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/deleteBatch',
        method: 'delete',
        data: data
      });
    },
    GET_MEMBERPICTURES_DETAIL_LIST: function GET_MEMBERPICTURES_DETAIL_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberPictures/getDetailList',
        method: 'post',
        data: data
      });
    }
  };
});